export const AUTH = {
    SIGNIN_USER: 'SIGNIN_USER',
    SIGNIN_USER_SUCCESS: 'SIGNIN_USER_SUCCESS',
    SIGNIN_USER_FAIL: 'SIGNIN_USER_FAIL',
    SIGNOUT_USER: 'SIGNOUT_USER',
    SIGNOUT_USER_SUCCESS: 'SIGNOUT_USER_SUCCESS',
    SIGNOUT_USER_FAIL: 'SIGNOUT_USER_FAIL',
    CLEAR_ALERT: 'CLEAR_ALERT'
}

export const GLOBAL = {
    GET_CONTACTS: 'GET_CONTACTS',
    GET_FILTERED_CONTACTS: 'GET_FILTERED_CONTACTS',
    GET_CONTACTS_SUCCESS: 'GET_CONTACTS_SUCCESS',
    GET_CONTACTS_FAIL: 'GET_CONTACTS_FAIL',
    GET_CONTACTS_FILTERED_SUCCESS: 'GET_CONTACTS_FILTERED_SUCCESS',
    GET_CONTACTS_FILTERED_FAIL: 'GET_CONTACTS_FILTERED_FAIL',
    GET_RECENTS: 'GET_RECENTS',
    GET_RECENTS_SUCCESS: 'GET_RECENTS_SUCCESS',
    GET_RECENTS_FAIL: 'GET_RECENTS_FAIL',
    RESET_RECENTS: 'RESET_RECENTS',
    GET_LAST_CALL: 'GET_LAST_CALL',
    GET_LAST_CALL_SUCCESS: 'GET_LAST_CALL_SUCCESS',
    GET_LAST_CALL_FAIL: 'GET_LAST_CALL_FAIL',
    GET_DIDS: 'GET_DIDS',
    GET_DIDS_SUCCESS: 'GET_DIDS_SUCCESS',
    GET_DIDS_FAIL: 'GET_DIDS_FAIL',
    SET_MICRO_PHONE_PERMISSION_DENIED: 'SET_MICRO_PHONE_PERMISSION_DENIED',
    SET_INTERNET_CONNECTION_LOST: 'SET_INTERNET_CONNECTION_LOST',
    SET_MULTIPLE_TABS: 'SET_MULTIPLE_TABS',
    SET_NOTIFICATION_PERMISSION_DENIED: 'SET_NOTIFICATION_PERMISSION_DENIED',
    SET_CONTACTS_MODAL_VISIBLE: 'SET_CONTACTS_MODAL_VISIBLE',
    SET_TRANSFER_MODAL: 'SET_TRANSFER_MODAL',
    SET_KEYPAD_MODAL_VISIBLE: 'SET_KEYPAD_MODAL_VISIBLE',
    SET_APP_START_AUDIO_PLAYED: 'SET_APP_START_AUDIO_PLAYED',
    CLOSE_ALL_MODALS: 'CLOSE_ALL_MODALS',
    REQUEST_CONTACTS_START: 'REQUEST_CONTACTS_START',
    REQUEST_CONTACTS_FINISH: 'REQUEST_CONTACTS_FINISH',
    CLEAR_ALERT: 'CLEAR_ALERT',
    ERROR: 'ERROR',
    ALERT: 'ALERT',
    SET_TAB_ID: 'SET_TAB_ID'
}

export const CALL = {
    CHANGE_PHONE_NUMBER: 'CHANGE_PHONE_NUMBER',
    CHANGE_DESTINATION_NUMBER: 'CHANGE_DESTINATION_NUMBER',
    CHANGE_HOLD: 'CHANGE_HOLD',
    CHANGE_MUTE_MIC: 'CHANGE_MUTE_MIC',
    CHANGE_TIMER: 'CHANGE_TIMER',
    SETUP_CALL: 'SETUP_CALL',
    ADD_CALL: 'ADD_CALL',
    START_CALL: 'START_CALL',
    END_CALL: 'END_CALL',
    MERGE_CALLS: 'MERGE_CALLS',
    MINIMIZE_CALL: 'MINIMIZE_CALL',
    MAXIMIZE_CALL: 'MAXIMIZE_CALL',
    CHANGE_ACTIVE: 'CHANGE_ACTIVE',
    SET_PRIVATE_CALL: 'SET_PRIVATE_CALL',
    TRANSFER_SUCCESS: 'TRANSFER_SUCCESS',
    TRANSFER_FAIL: 'TRANSFER_FAIL',
    TRANSFER_CLEAR: 'TRANSFER_CLEAR',
    SET_TRANSFER: 'SET_TRANSFER',
    INVITE_TO_CALL: 'INVITE_TO_CALL',
    REMOVE_CALL: 'REMOVE_CALL',
    REMOVE_CALLS: 'REMOVE_CALLS',
    VALIDATION_ERROR_CALL: 'VALIDATION_ERROR_CALL',
    CLEAR_ALERT: 'CLEAR_ALERT',
    SEARCH_INTEGRATION_NUMBER: 'SEARCH_INTEGRATION_NUMBER',
    SEARCH_INTEGRATION_NUMBER_SUCCESS: 'SEARCH_INTEGRATION_NUMBER_SUCCESS',
    SEARCH_INTEGRATION_NUMBER_FAILED: 'SEARCH_INTEGRATION_NUMBER_FAILED',
    CREATE_INTEGRATION_CONTACT: 'CREATE_INTEGRATION_CONTACT',
    CREATE_INTEGRATION_CONTACT_SUCCESS: 'CREATE_INTEGRATION_CONTACT_SUCCESS',
    CREATE_INTEGRATION_CONTACT_FAILED: 'CREATE_INTEGRATION_CONTACT_FAILED'
}

export const PROFILE = {
    GET_PROFILE: 'GET_PROFILE',
    GET_PROFILE_SUCCESS: 'GET_PROFILE_SUCCESS',
    GET_PROFILE_FAIL: 'GET_PROFILE_FAIL',
    PUT_PROFILE: 'PUT_PROFILE',
    PUT_PROFILE_SUCCESS: 'PUT_PROFILE_SUCCESS',
    PUT_PROFILE_FAIL: 'PUT_PROFILE_FAIL',
    CHANGE_PROFILE: 'CHANGE_PROFILE',
    CHANGE_PROFILE_SUCCESS: 'CHANGE_PROFILE_SUCCESS',
    CHANGE_PROFILE_FAIL: 'CHANGE_PROFILE_FAIL',
    SEND_RESET_LINK: 'SEND_RESET_LINK',
    SEND_RESET_LINK_SUCCESS: 'SEND_RESET_LINK_SUCCESS',
    SEND_RESET_LINK_FAIL: 'SEND_RESET_LINK_FAIL',
    RESET_PASSWORD: 'RESET_PASSWORD',
    RESET_PASSWORD_SUCCESS: 'RESET_PASSWORD_SUCCESS',
    RESET_PASSWORD_FAIL: 'RESET_PASSWORD_FAIL',
    SET_DID: 'SET_DID',
    SET_DID_SUCCESS: 'SET_DID_SUCCESS',
    SET_DID_FAIL: 'SET_DID_FAIL',
    CLEAR_ALERT: 'CLEAR_ALERT'
}

export const USER_AGENT = {
    CHANGE_TRANSPORT: ' CHANGE_TRANSPORT',
    CHANGE_USER_AGENT: 'CHANGE_USER_AGENT',
    CHANGE_REGISTER_STATUS: 'CHANGE_REGISTER_STATUS',
    SET_REGISTERED_SELECT_STATUS: 'SET_REGISTERED_SELECT_STATUS',
    SET_CONNECTION_ERROR: 'SET_CONNECTION_ERROR',
    SET_RECONNECTION_FAILED: 'SET_RECONNECTION_FAILED',
    SET_CODEC_CAPABILITIES: 'SET_CODEC_CAPABILITIES'
}

export const SETTINGS = {
    SET_USER_MODE: 'SET_USER_MODE',
    GET_DEVICES: 'GET_DEVICES',
    GET_DEVICES_SUCCESS: 'GET_DEVICES_SUCCESS',
    GET_DEVICES_FAIL: 'GET_DEVICES_FAIL',
    CHANGE_VOLUME: 'CHANGE_VOLUME',
    CHANGE_MODE: 'CHANGE_MODE',
    CHANGE_CALL_PREFERENCES: 'CHANGE_CALL_PREFERENCES',
    CHANGE_DEVICE_CONFIG: 'CHANGE_DEVICE_CONFIG',
    CHANGE_AUTO_REJECT: 'CHANGE_AUTO_REJECT',
    CHANGE_AUTO_PICKUP: 'CHANGE_AUTO_PICKUP',
    SET_CODEC_PREFERENCES: 'SET_CODEC_PREFERENCES',
    SET_INTEGRATION_NUMBER_SEARCH: 'SET_INTEGRATION_NUMBER_SEARCH',
    SET_SEARCH_KAVKOMCRM_ONLY: 'SET_SEARCH_KAVKOMCRM_ONLY'
}
